export const BRAND = {
  name: "Drawn Into Legend",
  logo: "https://static.prod-images.emergentagent.com/jobs/f577895a-fbfb-472f-bfd1-813d30680340/images/43ece0fa6396a2ca208fde3a4e828c542aec719ca1a3e814f578135e50296d2a.jpeg",
  hero: "https://static.prod-images.emergentagent.com/jobs/f577895a-fbfb-472f-bfd1-813d30680340/images/6ed1912b35493010d7ca2e0e139e9529eebb9f68f89dba9dd8adffd0136e6551.jpeg",
};
